export const USER_STATUS = {
  UNAPPROVED: 'Unapproved',
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated'
};